import { defineMessages, type MessageDescriptor } from 'react-intl';

export type PresetName =
  | 'today'
  | 'yesterday'
  | 'last7'
  | 'last14'
  | 'last30'
  | 'thisWeek'
  | 'lastWeek'
  | 'thisMonth'
  | 'lastMonth'
  | 'last90'
  | 'last12months'
  | 'custom';

export type Preset = {
  name: PresetName;
  label: MessageDescriptor;
};

const presetLabels = defineMessages({
  today: { defaultMessage: 'Today', id: 'zWgbGgjUUg' },
  yesterday: { defaultMessage: 'Yesterday', id: '6dIxDP1C8c' },
  last7: { defaultMessage: 'Last 7 days', id: 'irFBKnJxBN' },
  last14: { defaultMessage: 'Last 14 days', id: 'BVVhyHbBsw' },
  last30: { defaultMessage: 'Last 30 days', id: 'Rfvi9/BMNS' },
  thisWeek: { defaultMessage: 'This Week', id: 'SWvHLrMffH' },
  lastWeek: { defaultMessage: 'Last Week', id: 'P3YB9A5Yho' },
  thisMonth: { defaultMessage: 'This Month', id: '3PZa76CbSu' },
  lastMonth: { defaultMessage: 'Last Month', id: 'cfMkrE1iIn' },
  last90: { defaultMessage: 'Last 90 days', id: 'mgYBYoL6zD' },
  last12months: { defaultMessage: 'Last 12 months', id: 'r5sWuCmw/Z' },
  custom: { defaultMessage: 'Custom date range', id: 'rTHJFyC6zQ' },
});

export const PRESETS: Preset[] = [
  { name: 'today', label: presetLabels.today },
  { name: 'yesterday', label: presetLabels.yesterday },
  { name: 'last7', label: presetLabels.last7 },
  { name: 'last14', label: presetLabels.last14 },
  { name: 'last30', label: presetLabels.last30 },
  { name: 'thisWeek', label: presetLabels.thisWeek },
  { name: 'lastWeek', label: presetLabels.lastWeek },
  { name: 'thisMonth', label: presetLabels.thisMonth },
  { name: 'lastMonth', label: presetLabels.lastMonth },
  { name: 'last90', label: presetLabels.last90 },
  { name: 'last12months', label: presetLabels.last12months },
  { name: 'custom', label: presetLabels.custom },
];
